import '../App.css';

export const ToastEmail = ({ id = 'nothing', toastClass = 'hide', text = 'nothing' }) => {
    return (
        <div id={id} className={toastClass}>
            <p className="text-toast-email">{text}</p>
        </div>
    )
} 